"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRedirectToOAuthRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getRedirectToOAuthRequestStatus = (0, _getRequestStatus.default)(_actions.EspSyncOAuthActionType.REDIRECT_TO_OAUTH);
exports.getRedirectToOAuthRequestStatus = getRedirectToOAuthRequestStatus;